module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/best-sellers/best-sellers-07-96988a71edf07c221c759269c66857f4.jpg";